import axios from 'axios';
import qs from 'qs';
import config from '@/config';
import store from '@/store';

const axiosInstance = axios.create();

const request = async ({action, options}) => {
  const user = store.state.user;

  options = { ...options, _user: JSON.stringify(user) }

  const headers = {};

  if (user) {
    if (user.login) headers['X-USER-LOGIN'] = user.login;
    if (user.token) headers['X-USER-TOKEN'] = user.token;
  }

  if (action !== 'get_tele2_number') {
    return await axiosInstance.post(
      config.hostname + '/api/api.php?action=' + action,
      qs.stringify(options),
      { headers }
    );
  } else {
    return await axiosInstance.post(
      config.hostname.replace('https', 'http') + '/__promo/index.php'
    );
  }
};

export default request;
